import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var CardInner = styled.div.withConfig({
  displayName: "partials__CardInner",
  componentId: "sc-lnz13j-0"
})(["display:flex;align-items:center;flex-direction:column;height:100%;padding:40px 32px;border:1px solid ", ";border-radius:8px;box-shadow:0 0 4px rgba(46,46,51,0.04);text-align:center;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 24px 16px;\n  "]))));
var Title = styled.p.withConfig({
  displayName: "partials__Title",
  componentId: "sc-lnz13j-1"
})(["margin-bottom:16px;font-size:26px;font-weight:700;line-height:36px;", ";"], maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-bottom: 0;\n    font-size: 20px;\n    line-height: 29px;\n  "]))));
export { CardInner, Title };